<template>
  <b-modal
    :id="`generate-project-pdf-${projectId}`"
    :ref="`generate-project-pdf-${projectId}`"
    hide-footer
    size="lg"
    centered
    content-class="rounded-8"
    @hide="clear"
  >
    <div class="mt-n5">
      <BlockHeader name="Generate PDF" />
      <div class="row">
        <div class="col-lg-6 col-sm-6 col-xs-6">
          <Select
            v-model="pdfLanguage"
            :options="languagesOptions"
            form-group-id="Language"
            placeholder="Language"
          />
        </div>
        <div class="col-lg-6 col-sm-6 col-xs-6 pt-1">
          <b-button
            variant="outline-primary"
            size="lg"
            class="px-4 mt-4"
            :disabled="!pdfLanguage"
            @click="onGeneratePdf"
          >
            {{ 'Generate PDF' | i18n }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axios from 'axios';

import Select from '../../../../common/select';
import BlockHeader from '../../../../common/block-header';
import { TRANSLATE_LANGUAGE } from '../../../../../../../../../constants';
import { AuthStorageMixin, NotificationMixin } from '../../../../../../mixins';

export default {
  name: 'GenerateProjectPdfModal',
  components: { Select, BlockHeader },
  mixins: [AuthStorageMixin, NotificationMixin],
  props: {
    projectId: {
      type: String,
      default: null,
    },
    generatePDF: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      pdfLanguage: '',
      languagesOptions: Object.keys(TRANSLATE_LANGUAGE).map((i) => ({ value: TRANSLATE_LANGUAGE[i], text: this.$translate(i) })),
    };
  },
  methods: {
    clear() {
      this.pdfLanguage = '';
    },
    async onGeneratePdf() {
      const language = this.pdfLanguage;
      this.$bvModal.hide(`generate-project-pdf-${this.projectId}`);
      await this.generatePDF(language);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}

::v-deep .line-height-28 {
  line-height: 28px;
}
</style>